import type { AssetAdministrationShellDescriptor } from '../../Descriptors/AssetAdministrationShellDescriptor';
import type { AssetKind } from '../../Metamodel/Enums/AssetKind';
import type { PagedResult } from '../Interfaces/PagedResult';
import type { PagingParams } from '../Interfaces/PagingParams';
import { assertValidAasResponse, assignPagingParams, assignSearchParams } from '../../Utils/Restutils';
import { ClientBase } from './ClientBase';

export class AasRegistryClient extends ClientBase {
  public async getShellDescriptors(
    assetKind?: AssetKind,
    assetType?: string,
    pagingParams?: PagingParams,
    signal?: AbortSignal,
  ): Promise<PagedResult<AssetAdministrationShellDescriptor>> {
    const params = new URLSearchParams();
    assignSearchParams(params, {
      assetKind,
      assetType,
    });
    assignPagingParams(params, pagingParams);
    const [request, response] = await this.request(
      'get',
      '/shell-descriptors',
      params,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async createShellDescriptor(
    descriptor: AssetAdministrationShellDescriptor,
    signal?: AbortSignal,
  ): Promise<AssetAdministrationShellDescriptor> {
    const [request, response] = await this.request(
      'post',
      '/shell-descriptors',
      undefined,
      JSON.stringify(descriptor),
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async getShellDescriptor(
    id: string,
    signal?: AbortSignal,
  ): Promise<AssetAdministrationShellDescriptor> {
    const [request, response] = await this.request(
      'get',
      `/shell-descriptors/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async replaceShellDescriptor(
    id: string,
    descriptor: AssetAdministrationShellDescriptor,
    signal?: AbortSignal,
  ): Promise<void> {
    const [request, response] = await this.request(
      'put',
      `/shell-descriptors/${id}`,
      undefined,
      JSON.stringify(descriptor),
      signal,
    );
    return await assertValidAasResponse(request, response, 'void');
  }

  public async deleteShellDescriptor(
    id: string,
    signal?: AbortSignal,
  ): Promise<void> {
    const [request, response] = await this.request(
      'delete',
      `/shell-descriptors/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response, 'void');
  }
}
